import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { PlaylistDetailsAPIModel, PlaylistDetailsAPIModelImpl } from './playlistdetailsapimodel';
import { PlaylistDetailsViewImpl } from './playlistdetailsview';
import { PlaylistDetailsCSSStyleImpl } from './playlistdetailscss';
import { ToneDto, ToneDtoImpl } from '../../../../core/dto/tonedto';
import Swiper from 'swiper';
import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';

export interface PlaylistDetailsComponentProps extends CRBTUIComponentProps
{
    playlistId: string;
    onPlaylistClick(playlistDto: ToneDto): void;
}

export interface PlaylistDetailsComponentHandler extends UIComponentHandler
{
    onDeleteClicked(): void;
    onPlaylistSelected(index: number, toneDto: ToneDto): void;
}

export interface PlaylistDetailsComponentState extends UIComponentState
{
    selectedPlaylistDto: ToneDto;
    selectedPlaylistIndex: number;
   playlistDtos: ToneDto[];
}

export class PlaylistDetailsComponent extends CRBTUIComponent<PlaylistDetailsComponentProps, PlaylistDetailsComponentState> implements
PlaylistDetailsComponentHandler
{
    swiper: Swiper;
    constructor(props: PlaylistDetailsComponentProps)
    {
      super(props);

      this.state = {playlistDtos:  [], selectedPlaylistIndex: 0, selectedPlaylistDto: new ToneDtoImpl()};
    }
    componentDidMount()
    {
        (this.getAPIModel() as PlaylistDetailsAPIModel).getPlaylist(this.props.playlistId);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PlaylistDetailsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PlaylistDetailsCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new PlaylistDetailsAPIModelImpl(applicationContext, apiModelHandler);
    }

    onPlaylistSelected(index: number, toneDto: ToneDto): void 
    {
        // this.swiper.slideTo(index, 1, false);

        // this.props.onPlaylistClick(toneDto);
        // (this.getAPIModel() as PlaylistDetailsAPIModel).getPlaylistDetails(toneDto.getContentId().split("|")[0]);
        // window.location.reload(false);
    }

    onDeleteClicked(): void 
    {
      (this.getAPIModel() as PlaylistDetailsAPIModel).deletePlaylist(this.state.selectedPlaylistDto);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
      if(feature === APIFeatures.GET_WISHLIST)
      {
        let index = 0;
        let selectedToneDto: ToneDto = this.state.selectedPlaylistDto;
        (data as ToneDto[]).forEach((toneDto: ToneDto, index1: number) => 
        {
           if(toneDto.getContentId().split("|")[0] === this.props.playlistId)
           {
             index = index1;
             selectedToneDto = toneDto;
           }
        });
         this.setState({playlistDtos: data as ToneDto[], selectedPlaylistIndex: index, 
          selectedPlaylistDto: selectedToneDto}, () =>
         {
             this.initializeSwiper();
             this.swiper.slideTo(index , 1 ,false);
         });
      }
      else if(feature === APIFeatures.DELETE_TONE)
      {
            // this.props.context.clearToneDetails();
            this.props.context.getRouterHistory().goBack();
      }
      else 
      {
         (this.getView() as PlaylistDetailsViewImpl).setListOfDatas(data as ToneDto[]);

        this.forceUpdateComponent();
      }
    }

    private initializeSwiper()
    {
      this.swiper = new Swiper('.swiper-container', {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 3,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 400,
          modifier: 1,
          
          slideShadows: true,
        },
        
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          
        },
      });

      this.swiper.on("slideChange", () =>
      {
         let toneDto1 = this.state.playlistDtos.find((toneDto: ToneDto, index1: number) => 
          {
              return this.swiper.activeIndex === index1;
          });

            this.setState({selectedPlaylistIndex: this.swiper.activeIndex, 
               selectedPlaylistDto: toneDto1 !== undefined ? toneDto1 : this.state.selectedPlaylistDto}, () =>
               {
                 if(toneDto1 !== undefined)
                 {
                   this.props.onPlaylistClick(toneDto1);
                   (this.getAPIModel() as PlaylistDetailsAPIModel).getPlaylistDetails(toneDto1.getContentId().split("|")[0]);
                 }
               });
      });
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailscomponent.tsx